export default __webpack_public_path__ + "fk-cp-zion/img/emptyOrders_f13d28.png";